var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38354 4H3.05021C2.68202 4 2.38354 4.29848 2.38354 4.66667V13.3333C2.38354 13.7015 2.68202 14 3.05021 14H11.7169C12.0851 14 12.3835 13.7015 12.3835 13.3333V9.41667",
    stroke: "#A4A6AD",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41357 9.30901C6.21831 9.50427 6.21831 9.82085 6.41357 10.0161C6.60883 10.2114 6.92542 10.2114 7.12068 10.0161L6.41357 9.30901ZM13.5905 2.83923L14.0905 2.83923L14.0905 2.33923L13.5905 2.33923L13.5905 2.83923ZM13.0905 6.69199C13.0905 6.96814 13.3143 7.19199 13.5905 7.19199C13.8666 7.19199 14.0905 6.96813 14.0905 6.69199L13.0905 6.69199ZM9.56546 2.33923C9.28931 2.33923 9.06546 2.56309 9.06546 2.83923C9.06546 3.11538 9.28931 3.33923 9.56546 3.33923V2.33923ZM7.12068 10.0161L13.944 3.19279L13.2369 2.48568L6.41357 9.30901L7.12068 10.0161ZM13.0905 2.83924L13.0905 6.69199L14.0905 6.69199L14.0905 2.83923L13.0905 2.83924ZM13.5905 2.33923L9.56546 2.33923V3.33923L13.5905 3.33923L13.5905 2.33923Z",
    fill: "#A4A6AD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.e92947d5.svg";
export { ForwardRef as ReactComponent };